export enum EChat {
  getList = 'chat/getList',
  getToken = 'chat/getToken',
};
